import { render, staticRenderFns } from "./WalletSearchForm.vue?vue&type=template&id=0b00f061&"
import script from "./WalletSearchForm.vue?vue&type=script&lang=ts&"
export * from "./WalletSearchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports